import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { FlowExecutionService } from '@core/services/entities/flow-execution.service';
import {
  CreateFlowExecutionRequestDto,
  ListFlowExecutionRequestDto,
} from '@domain/flow-execution/dtos/flow-execution-request.dtos';
import { FlowExecutionResponseDto } from '@domain/flow-execution/dtos/flow-execution-response.dto';
import { FlowExecutionRepository } from '@domain/flow-execution/repositories/flow-execution.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FlowExecutionRepositoryService implements FlowExecutionRepository {
  constructor(private flowExecutionService: FlowExecutionService) {}

  create(
    request: CreateFlowExecutionRequestDto,
  ): Observable<ApiResponse<FlowExecutionResponseDto>> {
    return this.flowExecutionService.create(request);
  }

  list(
    request: ListFlowExecutionRequestDto,
  ): Observable<ApiResponse<PageableResponse<FlowExecutionResponseDto>>> {
    return this.flowExecutionService.list(request);
  }

  show(request: RefId): Observable<ApiResponse<FlowExecutionResponseDto>> {
    return this.flowExecutionService.show(request);
  }

  cancel(request: RefId): Observable<ApiResponse<FlowExecutionResponseDto>> {
    return this.flowExecutionService.cancel(request);
  }

  revert(request: RefId): Observable<ApiResponse<FlowExecutionResponseDto>> {
    return this.flowExecutionService.revert(request);
  }
}
